// src/services/api/SSOService.js
import ApiService from '../base/BaseApiService';

/**
 * ワンタイムコードをアクセストークンに交換する
 * @param {string} code - バックエンドから発行されたワンタイムコード
 * @returns {Promise<Object>} - アクセストークンを含むレスポンス
 * @throws {Error} - トークン交換失敗時
 */
export const tokenExchange = async (code) => {
  try {
    console.log('SSO: トークン交換を開始');
    
    // ワンタイムコードをアクセストークンに交換
    const result = await ApiService.post('/sso/token-exchange', {
      code: code
    });
    
    console.log('SSO: トークン交換が完了しました');
    return result;
  } catch (error) {
    console.error('SSO: トークン交換エラー:', {
      errorId: error.errorId,
      status: error.response?.status,
      detail: error.response?.data?.detail
    });
    throw error;
  }
};

export default {
  tokenExchange
};
